import { AxiosInstance } from "axios";
import config from "config";

const getApiBase = () => config.apollo.uri.replace(/\/graphql\/?$/, "");

export const placingSlipEndpoints = {
    upload: (offerId: string) =>
        `/api/upload-unsigned-placing-slip/${offerId}`,
    view: (offerId: string) => `/api/view-unsigned-placing-slip/${offerId}`,
    delete: (offerId: string) =>
        `/api/delete-unsigned-placing-slip/${offerId}`,
    viewSigned: (offerId: string, reinsurerId: string) =>
        `/api/view-signed-placing-slip/${offerId}/${reinsurerId}`,
};

export const getPlacingSlipViewUrl = (offerId: string) =>
    `${getApiBase().replace(/\/$/, "")}${placingSlipEndpoints.view(offerId)}`;

export const checkPlacingSlipExists = async (
    api: AxiosInstance,
    offerId: string,
): Promise<boolean> => {
    try {
        await api.get(placingSlipEndpoints.view(offerId));
        return true;
    } catch (error: any) {
        if (error?.response?.status === 404) {
            return false;
        }
        throw error;
    }
};

export const uploadUnsignedPlacingSlip = async (
    api: AxiosInstance,
    offerId: string,
    file: File,
) => {
    const formData = new FormData();
    formData.append("file", file);

    await api.post(placingSlipEndpoints.upload(offerId), formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const deleteUnsignedPlacingSlip = async (
    api: AxiosInstance,
    offerId: string,
) => {
    await api.delete(placingSlipEndpoints.delete(offerId));
};

export const fetchPlacingSlipBlobUrl = async (
    api: AxiosInstance,
    offerId: string,
): Promise<string> => {
    const response = await api.get(placingSlipEndpoints.view(offerId), {
        responseType: "blob",
    });
    const contentType =
        response.headers["content-type"] || "application/pdf";
    const blob = new Blob([response.data], { type: contentType });
    return URL.createObjectURL(blob);
};

export const fetchSignedPlacingSlipBlobUrl = async (
    api: AxiosInstance,
    offerId: string,
    reinsurerId: string,
): Promise<string> => {
    const response = await api.get(
        placingSlipEndpoints.viewSigned(offerId, reinsurerId),
        {
            responseType: "blob",
        },
    );
    const contentType =
        response.headers["content-type"] || "application/pdf";
    const blob = new Blob([response.data], { type: contentType });
    return URL.createObjectURL(blob);
};

export const openPlacingSlipView = async (
    api: AxiosInstance,
    offerId: string,
) => {
    const blobUrl = await fetchPlacingSlipBlobUrl(api, offerId);
    window.open(blobUrl, "_blank", "noopener,noreferrer");
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
};

export const getPendingPlacingSlipFiles = (placingSlip: any): File[] =>
    placingSlip?.pendingFiles || [];
